<template>
	<v-container fluid>
		<sliders :height="$vuetify.breakpoint.smAndDown ? '300px' : '600px'" :contain="true"></sliders>
		<v-skeleton-loader v-if="loading" type="list-item-three-line"></v-skeleton-loader>
		<v-stepper v-if="!loading" v-model="step" vertical>
			<!-- Date Selector -->
			<v-stepper-step :step="1" :complete="!!date">
				<v-flex column align-center>
					<div class="mx-1">
						<h2>{{ "date" | trans }}</h2>
					</div>
					<span class="mx-1 caption" v-if="date">
						{{ date | moment("calendar") }}
					</span>
				</v-flex>
			</v-stepper-step>
			<v-stepper-content :step="1">
				<default-field
					:props="{
						text: 'date',
						type: 'date',
						prependInnerIcon: 'mdi-calendar',
						allowedDates: onlySevenDays,
						outlined: true,
					}"
					@input="() => step++"
					v-model="date"
				>
				</default-field>
			</v-stepper-content>

			<!-- Turno Selector -->
			<v-stepper-step :step="2" :complete="!!date">
				<v-flex colun align-center>
					<div class="mx-1">
						<h2>{{ "horarios" | trans }}</h2>
					</div>
					<span class="mx-1 caption" v-if="turno">
						{{ api.objects.horarios.find((h) => h.id === turno).full_name }}
					</span>
				</v-flex>
			</v-stepper-step>
			<v-stepper-content :step="2">
				<default-field
					:props="{
						text: 'horarios',
						type: 'resource',
						resource: 'horarios',
						prependInnerIcon: 'mdi-calendar',
						allowedDates: onlySevenDays,
						outlined: true,
					}"
					@input="() => step++"
					v-model="turno"
				>
				</default-field>
				<v-btn color="#f39664" @click="stepBack()" large :block="$vuetify.breakpoint.mdAndDown">{{
					"crud.back" | trans
				}}</v-btn>
			</v-stepper-content>

			<!-- job place Selector -->
			<v-stepper-step :step="3" :complete="!!date">
				<v-flex column align-center>
					<div class="mx-1">
						<h2>{{ "job places" | trans }}</h2>
					</div>
					<span class="mx-1 caption" v-if="job_place">
						{{ api.objects.puestos.find((h) => h.id === job_place).full_name }}
					</span>
				</v-flex>
			</v-stepper-step>
			<v-stepper-content :step="3">
				<default-field
					:props="{
						text: 'job place',
						type: 'resource',
						resource: 'puestos',
						prependInnerIcon: 'mdi-calendar',
						allowedDates: onlySevenDays,
						outlined: true,
					}"
					@input="() => step++"
					v-model="job_place"
				>
				</default-field>
				<v-btn color="#f39664" @click="stepBack()" large :block="$vuetify.breakpoint.mdAndDown">{{
					"crud.back" | trans
				}}</v-btn>
			</v-stepper-content>

			<template v-for="(category, index) in categories">
				<v-stepper-step :key="category.id + '-header'" :complete="step > index + 4" :step="index + 4">
					<v-flex row align-center>
						<v-avatar size="30" tile class="mx-1">
							<v-img :src="category.image_url"></v-img>
						</v-avatar>
						<v-flex column align-center>
							<div class="mx-1">
								<h2 :style="{ color: category.color }">{{ category.full_name }}</h2>
								<small v-if="category.descripción">{{ category.descripción }}</small>
							</div>
							<span class="mx-1 caption" v-if="selectedProducts[index]">
								{{ selectedProducts[index].name }}
							</span>
						</v-flex>
					</v-flex>
				</v-stepper-step>
				<v-stepper-content height="400px" :key="category.id + '-body'" :step="index + 4">
					<v-row height="400px">
						<v-col v-for="product in perCategoria(category.id)" :key="product.id" cols="12" sm="6" md="3">
							<v-card height="230px" style="overflow: scroll" @click="selectProduct(product)" class="pa-2" outlined>
								<v-img :src="product.image_url" contain height="150"></v-img>
								<h4 class="text-center">{{ product.name }}</h4>
							</v-card>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<v-card height="230px" style="overflow: scroll" @click="selectProduct(null)" class="pa-2" outlined>
								<v-img :src="api.url + 'img/no-select.png'" contain height="150"></v-img>
								<h4 class="text-center">{{ "no select" | trans }}</h4>
							</v-card>
						</v-col>
					</v-row>
					<v-btn class="ma-1" color="#f39664" @click="stepBack()" large :block="$vuetify.breakpoint.mdAndDown">{{
						"crud.back" | trans
					}}</v-btn>
				</v-stepper-content>
			</template>

			<!-- confirm order -->
			<v-stepper-step :step="categories.length + 4">
				<v-flex row align-center>
					<div class="mx-1">
						<h2>{{ "confirm" | trans }} {{ "order" | trans }}</h2>
					</div>
				</v-flex>
			</v-stepper-step>
			<v-stepper-content :step="categories.length + 4">
				<v-list two-line subheader>
					<v-subheader> {{ "selected" | trans }} {{ "products" | trans }} </v-subheader>
					<template v-for="(product, index) in selectedProducts">
						<v-list-item v-if="product" :key="index">
							<v-list-item-avatar>
								<v-img :src="product.image_url"></v-img>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>{{ product.name }}</v-list-item-title>
								<v-list-item-subttitle :style="{ color: getCategory(product.categoria_id).color }">{{
									getCategory(product.categoria_id).full_name
								}}</v-list-item-subttitle>
							</v-list-item-content>
							<v-list-item-action> {{ "quantity" | trans }}: 1 </v-list-item-action>
						</v-list-item>
						<v-divider v-if="product" :key="index + '-div'"></v-divider>
					</template>
				</v-list>
				<v-layout row class="pa-3">
					<v-btn color="#f39664" @click="stepBack()" large :block="$vuetify.breakpoint.mdAndDown">{{
						"crud.back" | trans
					}}</v-btn>
					<v-spacer></v-spacer>
					<v-btn class="ma-1" @click="saveOrder" large :block="$vuetify.breakpoint.mdAndDown" color="#A6BB99"
						>{{ "confirm" | trans }} {{ "order" | trans }}</v-btn
					>
					<v-btn class="ma-1" color="#f39664" @click="cancelOrder" large :block="$vuetify.breakpoint.mdAndDown">{{
						"crud.cancel" | trans
					}}</v-btn>
				</v-layout>
			</v-stepper-content>
		</v-stepper>
	</v-container>
</template>
<script>
import moment from "moment";
import DefaultField from "@/components/main/DefaultField.vue";
import Sliders from "@/components/main/Sliders";
export default {
	components: {
		DefaultField,
		Sliders,
	},
	async mounted() {
		this.getData();
	},
	data() {
		return {
			products: [],
			categories: [],
			selectedProducts: [],
			step: 1,
			loading: false,
			date: null,
			job_place: null,
			turno: null,
		};
	},
	methods: {
		async getData() {
			this.loading = true;
			this.products = await this.api.load("productos?scope[active]=1");
			this.categories = await this.api.load("categorias-productos?whereNull[]=parent_id");
			this.loading = false;
		},
		perCategoria(categoriaId) {
			return this.products.filter((product) => product.categoria_id === categoriaId);
		},
		getCategory(categoriaId) {
			return (
				this.categories.find((category) => category.id === categoriaId) || {
					full_name: "No category",
					color: "black",
				}
			);
		},
		selectProduct(product) {
			this.selectedProducts.push(product);
			this.step++;
		},
		onlySevenDays(date) {
			const sevenDaysFromNow = moment().add(7, "days");
			return moment(date).isBefore(sevenDaysFromNow) && moment(date).isAfter(moment());
		},
		async saveOrder() {
			const items = this.selectedProducts
				.filter((i) => i)
				.map((i) => {
					return {
						producto_id: i.id,
						cantidad: 1,
						precio: i.precio,
						impuesto: i.impuesto,
						advanced_stock_index: i.advanced_stock_index,
						name: i.name,
						description: i.description,
						referencia: i.referencia,
						image_id: i.image_id,
					};
				});
			const payload = {
				user_id: this.api.user.id,
				cliente_id: this.api.user.cliente_id || 1,
				direccion_envio: this.api.user.direccion,
				items: items,
				estado: "Pedido",
				fecha_entrega: this.date ? moment(this.date).utc().format() : undefined,
				facturar: false,
			};
			await this.api.post("pedidos", payload);
			this.$router.push({ name: "orders" });
		},
		cancelOrder() {
			this.selectedProducts = [];
			this.step = 1;
			this.date = null;
			this.job_place = null;
			this.turno = null;
		},
		stepBack() {
			this.step--;
			if (this.step < 1) {
				this.step = 1;
			}
			if (this.step === 1) {
				this.date = null;
			}
			if (this.step === 2) {
				this.turno = null;
			}
			if (this.step === 3) {
				this.job_place = null;
			}
			if (this.step > 3 && this.selectedProducts.length > 0) {
				this.selectedProducts.pop();
			}
		},
	},
};
</script>
